import { Component, OnInit, Input } from '@angular/core';
import { ECharts, EChartOption, EChartTitleOption } from 'echarts';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { ProgressPieService } from './progress-pie.service';
import { ChartOptionService } from '../../service/chart-option.service';
import { ChartResizeService } from '../../service/chart-resize.service';

@Component({
  selector: 'bcac-progress-pie',
  templateUrl: './progress-pie.component.html',
  styleUrls: ['./progress-pie.component.scss']
})
export class ProgressPieComponent implements OnInit {

  constructor(
    private commonService: CommonService,
    private progressPieService: ProgressPieService,
    private chartOptionService: ChartOptionService,
    private chartResizeService: ChartResizeService
  ) { }

  chartTitle = {
    show: true,
    label: '图表标题'
  }

  // 布局设置
  cardPadding = "1rem";
  cardBgColor = "#fff";
  chartTitleColor = "";

  // echart图表元素
  chartBackgroundColor: string = "#FFF";
  chartColors: string[] = this.chartOptionService.getChartColors('default');
  chartTitles = this.progressPieService.getDefaultChartTitle();
  chartTextStyle = this.chartOptionService.getTextStyle();
  pieSeries: EChartOption.SeriesPie = this.progressPieService.getProgressPieSeries();
  chartSeriesList: EChartOption.Series[] = [];

  chartOption = {
    backgroundColor: this.chartBackgroundColor,
    title: this.chartTitles,
    series: this.chartSeriesList,
    color: this.chartColors,
    textStyle: this.chartTextStyle
  };

  initOpts = this.chartOptionService.getInitOpts();
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }

  @Input()
  set bcacDarkMode(darkMode: boolean) {
    if (darkMode == true) {
      this.progressPieService.changeChartTitleDark(this, darkMode);
      this.progressPieService.chartBackgroundColorDarkMode(this.chartOption);
      this.progressPieService.colorsDarkMode(this.chartColors);
      this.progressPieService.seriesDarkMode(this.pieSeries);
      this.progressPieService.chartTitleDarkMode(this.chartTitles);
    }
  }

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.progressPieService.setSmallModePadding(this);
    }
  }

  // 标题开关
  @Input()
  set bcacTitleSwithch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }

  // 标题
  @Input()
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }


  @Input()
  set bcacColors(colorList: string[]) {
    this.progressPieService.chartColorsChange(this.chartColors, colorList);
  }

  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  @Input()
  set bcacRadius(radius: string[]) {
    this.progressPieService.changeChartRadius(this.pieSeries, radius)
  }

  // 选择图形方向 true:顺时针 
  @Input()
  set bcacClockWise(clockWise: boolean) {
    this.progressPieService.changePieClockWise(clockWise, this.pieSeries);
  }

  @Input()
  set bcacChartData(chartData: any) {
    this.progressPieService.buildSeries(chartData, this.chartSeriesList, this.pieSeries)
    this.updateOption();
  }

  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }


  @Input()
  set bcacChartTitle(chartTitle) {
    this.progressPieService.setChartTitle(chartTitle, this.chartTitles)
  }

  @Input()
  set bcacCenter(center: number | string | Array<any>) {
    this.progressPieService.setPieCenter(center, this.pieSeries)
  }


  legendChange($event) {
    this.progressPieService.topLegendChange($event, this.optionInit);
  }


  options;
  // echart配置项  
  initEchart() {
    this.options = this.chartOption;
  }

  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true)
    }
  }

  ngOnInit() {
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdaptPieWithRichLabel(this.optionInit, this.options)
    })
  }

}
